module.exports = __webpack_public_path__ + "img/app-dne-download-android.83c953ec.svg";